import { oldBaseApi } from "../../api";

export interface PhysicalAddress {
  addressId: string;
  office: string | null;
  street: string;
  area: string;
  city: string;
  country: string;
  countryIsoCode: string;
  createDateTime: string;
  house: string;
  postalCode: string;
  region: string;
  unrestrictedValue: string;
}

export interface Organization {
  apiToken: string | null;
  createDateTime: string | null;
  externalId: string | null;
  inn: string;
  integrations: string[];
  legalAddress: string | null;
  name: string;
  ogrn: string;
  ogrnDate: string;
  phone: string;
  physicalAddress: PhysicalAddress;
  sro: string;
  sroDate: string;
  sroEngineering: string;
  sroEngineeringDate: string;
  sroEngineeringInn: string;
  sroEngineeringName: string;
  sroEngineeringOgrn: string;
  sroIssuerInn: string;
  sroIssuerName: string;
  sroIssuerOgrn: string;
}

export const getOrganization = async (): Promise<Organization> => {
  const response = await oldBaseApi.get<Organization>(
    `api/organization/`,
  );
  return response.data;
};
